import React from 'react'
import classnames from 'classnames'
const Row = ({ children, className, ...rest }) => (
  <div className={classnames('cookunity__form_column', className)} {...rest}>
    {children}
  </div>
)

export default Row



// WEBPACK FOOTER //
// ./src/components/Form/Column.jsx